import React from 'react'
import Divider from '../../Divider'
import NoPadH3 from '../../titles/NoPadH3'
import { Button, Form, Col, Row } from 'react-bootstrap'

const DiscountForm = () => {
  return (<>
    <NoPadH3>Create / Edit Discount</NoPadH3>
    <Divider />
    <Form style={{paddingBottom: "60px"}} className="p-2 p-md-4">
      <Row>
        <Col sm={12}>
          <Form.Group className="mb-3" controlId="formDiscountName">
              <Form.Label>Discount Name</Form.Label>
              <Form.Control type="text" placeholder="Black Friday" />
          </Form.Group>
        </Col>
        <Col sm={12}>
          <Form.Group className="mb-3" controlId="formDiscountDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control type="text" />
          </Form.Group>
        </Col>
        <Col sm={6}>
        <Form.Group className="mb-3">
          <Form.Label>Target</Form.Label>
          <Form.Select>
            <option value="all">All</option>
            <option value="id">ID</option>
            <option value="username">Username</option>
            <option value="first_name">First Name</option>
            <option value="first_name">Last Name</option>
          </Form.Select>
        </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Enter value</Form.Label>
              <Form.Text className="text-muted">
                {" "}(Contains expect for ID)
              </Form.Text>
              <Form.Control type="text" placeholder="" />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label>Target Amount</Form.Label>
            <Form.Text className="text-muted">
                {" "}(Total Purchased)
              </Form.Text>
            <Form.Select>
              <option value="more">More Than</option>
              <option value="less">Less Than</option>
              <option value="equal_to">Equal To</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label>Amount $</Form.Label>
            <Form.Control type="number" step="0.01" />
          </Form.Group>
        </Col>
        <Col sm={6} className="h-100">
          <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>From</Form.Label>
              <Form.Control type="date"  placeholder="" />
          </Form.Group>
        </Col>
        <Col sm={6} className="h-100">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>To</Form.Label>
            <Form.Control type="date"  placeholder="" />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label>Discount Type</Form.Label>
            <Form.Text className="text-muted">
                {" "}(Total Purchased)
              </Form.Text>
            <Form.Select>
              <option value="percentage">%</option>
              <option value="fixed_amount">Fixed Amount</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group className="mb-3">
            <Form.Label>Amount</Form.Label>
            <Form.Control type="number" step="0.01" />
          </Form.Group>
        </Col>
        <Col sm={12} className="d-flex justify-content-center">
          <Button variant="outline-dark py-2 px-4 fs-4 text-center mt-2 w-100" type="submit">
              Submit
          </Button>
        </Col>
      </Row>
    </Form>
  </>)
}

export default DiscountForm